import { createFileRoute } from "@tanstack/react-router";
import PanicAnxietyDepression from "@/pages/PanicAnxietyDepression";
export const Route = createFileRoute("/panic-anxiety-depression")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Panic Anxiety Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Panic, anxiety, and depression often overlap. Learn about TMS, SAINT TMS, and treatment options for complex symptoms in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Panic Anxiety Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Panic, anxiety, and depression often overlap. Learn about TMS, SAINT TMS, and treatment options for complex symptoms in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/panic-anxiety-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/panic-anxiety-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PanicAnxietyDepression />;
}
